import React, { useState } from "react"
import Modal from "react-bootstrap/Modal";
import useMediaQuery from "app/hooks/useMediaQuery";
import "./SobrePagoObligacionesModal.css"

function SobrePagoObligacionesModal(abrirDefecto = true) {

    const enlaceDocumento = "https://apiinformativa.cs.fi.cr/CSCMS/media/Comunicado%20Sitio%20Web%20Inhabilitaci%C3%B3n%20canales%20de%20pago%205-8-2024.pdf#navpanes=0"

    const isMobile = useMediaQuery("(max-width: 1023px)")

    const [abrirModal, setAbrirModal] = useState(abrirDefecto)

    return (
        <>
            <Modal size="xl" show={abrirModal} onHide={() => setAbrirModal(false)}>
                <Modal.Header
                    closeButton
                    style={
                        isMobile
                            ? {
                                backgroundColor: "#f1f1f1",
                                borderBottom: "0px",
                                padding: "32px 34px 0px 32px",
                            }
                            : {
                                backgroundColor: "#f1f1f1",
                                borderBottom: "0px",
                                padding: "32px 66px 0px 60px",
                            }
                    }
                >
                    <Modal.Title
                        style={
                            isMobile
                                ? { fontSize: "22px", color: "#001a70" }
                                : { fontSize: "36px", color: "#001a70" }
                        }
                    >
                        Sobre el pago de obligaciones
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ backgroundColor: "#f1f1f1" }} className="informacion-pago-cuerpo">
                    <iframe
                        className="informacion-pago-visor-documento"
                        src={enlaceDocumento}
                        title="Documento pdf"
                    />
                </Modal.Body>
            </Modal>
        </>
    )
}

export default SobrePagoObligacionesModal
